import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};

const routes = [
    {
        path: '/',
        name: 'indexZh',
        component: () => import('../views/indexZh.vue')
    },
    {
        path: '/indexEn',
        name: 'indexEn',
        component: () => import('../views/indexEn.vue')
    },
];

const router = new VueRouter({
    routes
});

export default router
